import { useContext } from "react";
import { AccountContext } from "../AccountContext";
import {
    useGetPersistentDebtStatusForAccount,
    useGetPayDownPlanQuotes,
    useGetAccountPayDownPlanQuotesStatus,
    useGetAccountPayDownEligibleBalances
} from "../../../sdk/ams/Delinquency";
import PayDownPlanQuotesTable from "./PayDownPlanQuotesTable";
import PayDownPlanQuotesStatus from "./PayDownPlanQuotesStatus";
import PayDownNoticeStatus from "./PayDownNoticeStatus";
import PayDownEligibleBalances from './PayDownEligibleBalances';
import { JsonModal } from '../../../shared/JsonModal';
import { Table, TableBody, TableRow, TableCell, Segment, Header } from "semantic-ui-react";

export default function PayDownPlan() {
    const { accountId } = useContext(AccountContext);
    const { data: persistentDebtStatus } = useGetPersistentDebtStatusForAccount(accountId);
    const { data: payDownPlanQuotes } = useGetPayDownPlanQuotes(accountId);
    const { data: accountPayDownPlanQuotesStatus } = useGetAccountPayDownPlanQuotesStatus(accountId);
    const { data: accountEligibleBalances } = useGetAccountPayDownEligibleBalances(accountId);

    const payDownPlanQuotesAvailable = payDownPlanQuotes && payDownPlanQuotes.quotes;

    return (
        <div>
            <section>
                <Segment>
                    <Header as="h2">Persistent Debt</Header>
                    <Table definition collapsing>
                        <TableBody>
                            <TableRow>
                                <TableCell>Persistent Debt Status</TableCell>
                                <TableCell>{persistentDebtStatus?.status} <JsonModal header="Persistent Debt Status Details" jsonContent={persistentDebtStatus} /></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Segment>
            </section>
            <section>
                <PayDownEligibleBalances accountId={accountId} paydownEligibleBalances={accountEligibleBalances} />
            </section>
            <section>
                <PayDownPlanQuotesStatus accountId={accountId} payDownPlanQuotesStatus={accountPayDownPlanQuotesStatus} />
            </section>
            <section>
                <PayDownNoticeStatus paydownPlanStatusReponse={accountPayDownPlanQuotesStatus} />
            </section>
            <section>
                {payDownPlanQuotesAvailable &&
                    <PayDownPlanQuotesTable accountId={accountId} payDownPlanQuotes={payDownPlanQuotes} />
                }
                {!payDownPlanQuotesAvailable &&
                    <p>There are no Pay Down Plan Quotes</p>
                }
            </section>
        </div>
    );
}